import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"

const AddressPageConfig = [
    { span: 6, height: "40px", classes: "marginTop-32" },
    { span: 6, height: "24px", classes: "marginTop-48" },
    { span: 6, height: "18px", classes: "marginTop-56" },
    { span: 8, height: "195px", classes: "marginTop-16" },
    { span: 6, height: "18px", classes: "marginTop-24" },
    {
        classes: "marginTop-16",
        columns: [
            {
                span: 8,
                height: "195px",
            },
            {
                span: 8,
                height: "195px",
            },
            {
                span: 8,
                height: "195px",
            },
        ],
    },
]

function AddressSkeleton() {
    return (
        <div className="flex page-container">
            <Skeleton config={AddressPageConfig}></Skeleton>
        </div>
    )
}

export default AddressSkeleton
